import React, { useState, useEffect } from "react";
import { Redirect } from 'react-router-dom'
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";


import {
  USNNumber,
  mainPageData,
  pageHeaderData
} from "./sampleData/sampleData";
import {
  profileAPI,
  headerAPI,
  _link,
  mainPageAnchors,
  getyouTubePlayList,
  gettwitchChannel,
  showFooter,
} from "../common/utilities";

import styles from "./ErrorPage.module.scss";
import { useTranslation, Trans } from 'react-i18next';
import cfLogoImg from "../images/cf-logo.png";

import errorImgDesktop from "../images/image-error-desktop.jpg";
import errorImgDesktopBR from "../images/image-error-desktop-br.jpg";
// import errorImgMobile from "../images/image-error-mobile.jpg";


const maxSectWidth = "lg";

function FooterLinks() {
  const { t } = useTranslation();

  return (
    <div className={styles.footer_links}>
      <a href={_link["url_crossfire"]}>{t('Crossfire')}</a>
      <a href={_link["cf_web_shop_url"]}>{t('Webstore')} </a>
      <a href={_link["forum_url"]}>{t('Forums')}</a>
      <a href={_link["submit_ticket_url"]}>{t('Support')}</a>
    </div>
  );
}

export default function ErrorPage(props) {
  const { match, creator, devUSN, useSampleData } = props;

  const { t } = useTranslation();

  const [pageData, setPageData] = useState(null);
  const [headerData, setHeaderData] = useState(null);
  const [pageStatus, setPageStatus] = useState(true);

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  showFooter();

  return (
    <section id={mainPageAnchors.OVERVIEW.id} className={styles.overview}>
    <Container
          maxWidth={maxSectWidth}
          classes={{ root: styles.overview_content }}
        >
      
      <Box display="flex" justifyContent="center" m={0} p={0} mb={1}>
        <Box p={0}>
          <img
            src={`${cfLogoImg}`}
            className={styles.cflogoImage}
          />
        </Box>
      </Box>

      <Trans>
        <Box display="flex" justifyContent="center" m={0} p={0} mb={2}>
          <Box p={0}>
            <h1 className={styles.title}>{`Oops!`}</h1>
          </Box>
        </Box>

        <Box display="flex" justifyContent="center" m={0} p={0} mb={2}>
          <Box p={0}>
            <div className={styles.description}>{t('No information available. Try again later.')}</div>
          </Box>
        </Box>
      </Trans>
      
      <Box display="flex" justifyContent="center" m={0} p={0} mb={1}>
        <Box p={0}>
          <img
            src={`${window._region === 'BR' ? errorImgDesktopBR : errorImgDesktop}`}
            className={styles.errorImage}
          />
        </Box>
      </Box>
      
      <Box display="flex" justifyContent="center" m={0} p={0} mb={1}>
        <Box p={0}>
           <Button variant="outlined" href={_link["url_crossfire_na"]} className={styles.button}>
            {t('Crossfire Home')}
          </Button>
        </Box>
      </Box>
      
    </Container>
    </section>
  );
}
